<template>
  <div class="product-cover-component"
       :class="[
         `type-${type}`,
       ]"
  >
    <ym-img class="img"
            :radius="4"
            :src="cover"
            :alt="alt"
            :lazy="lazy"
    />
  </div>
</template>

<script>
  export default {
    name: 'ProductCoverComponent',
    props: {
      cover: {
        type: String,
        required: true,
      },
      alt: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        default: 'normal-horizontal-rect',
        validator(val) {
          return [
            'normal-horizontal-rect',
            'medium-horizontal-rect',
            'large-horizontal-rect',
            'extra-large-horizontal-rect',
            'small-vertical-rect',
            'normal-vertical-rect',
            'normal-small-square',
            'normal-square',
          ].includes(val);
        },
      },
      lazy: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-cover-component {
    flex-shrink: 0;
    overflow: hidden;
    box-sizing: border-box;
    &.type-normal-horizontal-rect {
      width: @product-cover-width;
      height: @product-cover-height;
    }
    &.type-medium-horizontal-rect {
      width: 210px;
      height: 148px;
    }
    &.type-large-horizontal-rect {
      width: 220px;
      height: 165px;
    }
    &.type-extra-large-horizontal-rect {
      width: 250px;
      height: 188px;
    }
    &.type-small-vertical-rect {
      width: 150px;
      height: 200px;
    }
    &.type-normal-vertical-rect {
      width: 150px;
      height: 210px;
    }
    &.type-normal-small-square {
      width: 120px;
      height: 120px;
    }
    &.type-normal-square {
      width: 150px;
      height: 150px;
    }
    .img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: @border-radius-normal;
      border: @border-base;
      box-sizing: border-box;
    }
  }

</style>
